import { createContext } from 'react'

const AppStateContext = createContext(null)
AppStateContext.displayName = 'AppState'

export default AppStateContext